import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class vengo
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.vengo = {};

/**
 * Retrieves Vengo credentials
 * @param {ReachAPI.Security} security
 * @param {number} widgetId
 * @throws {ReachApiError}
 * @returns {Promise<ReachApiResponse>}
 * @memberof ReachAPI.vengo
 */
ReachAPI.vengo.getCredentials = function (security, widgetId) {
    var url = ReachAPI.server + '/signage/vengo/credentials/' + widgetId;
    var params = {};
    var jqPromise;

    params = security.merge(params);
    jqPromise = ReachAPI.get(url, 'json', params);

    jqPromise.done(function () {
        Log.Debug('Retrieved Vengo credentials from the REACH API', null, __fileline);
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve vengo  credentials',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return ReachAPI.deferredToPromise(jqPromise);
};
